module.exports = __webpack_public_path__ + "static/media/Typhlosion_gaussian2.90dc8c72.png";